var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "services_manager",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29094",
    "data-name": "Path 29094",
    d: "M20,12.2v1.7c0,3.15-1.8,4.5-4.5,4.5h-9C3.8,18.4,2,17.05,2,13.9V8.5C2,5.35,3.8,4,6.5,4H9.2A3.854,3.854,0,0,0,9,5.25v3.9a3.263,3.263,0,0,0,.89,2.36,3.263,3.263,0,0,0,2.36.89v1.39a.655.655,0,0,0,1.01.54l2.89-1.93h2.6A3.854,3.854,0,0,0,20,12.2Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29095",
    "data-name": "Path 29095",
    d: "M7.4,22h7.2M11,18.4V22M22,5.25v3.9a3.048,3.048,0,0,1-2,3.05,3.854,3.854,0,0,1-1.25.2h-2.6l-2.89,1.93a.655.655,0,0,1-1.01-.54V12.4a3.263,3.263,0,0,1-2.36-.89A3.263,3.263,0,0,1,9,9.15V5.25A3.854,3.854,0,0,1,9.2,4a3.048,3.048,0,0,1,3.05-2h6.5A3.071,3.071,0,0,1,22,5.25Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29096",
    "data-name": "Path 29096",
    d: "M18.5,7.25h.01m-2.809,0H15.7m-2.81,0h.01",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesManager);
export default __webpack_public_path__ + "static/media/services_manager.83de220b36a44b543d3a2145d9462dd0.svg";
export { ForwardRef as ReactComponent };